// One status change from the order page or the orders list, with the two
// questions the worker may send back instead of a refusal:
//   · « la même photo est placée deux fois » (owner, 2026-11-03, #WA-534144):
//     a warning — anyone who may change the status may « Continuer quand même »;
//   · « Forcer sans avance » (2026-10-15): admins only, with a written reason.
// Worker: lib/orderStatusChange.ts (print_warning, not_paid).
import { ordersApi } from './api';
import { isNotPaid, askOverrideReason } from './forceWithoutAdvance';

/** Is this error the « same photo twice » warning (409 can_continue)? */
export function isRepeatWarning(err: unknown): boolean {
  const e = err as { status?: number; body?: { code?: string; can_continue?: boolean } } | null;
  return e?.status === 409 && e?.body?.code === 'same_photo_twice' && e?.body?.can_continue === true;
}

export interface Ask {
  confirm: (msg: string) => boolean;
  prompt: (msg: string) => string | null;
}

const browserAsk: Ask = { confirm: (m) => window.confirm(m), prompt: (m) => window.prompt(m) };

/** Change the status, asking when the worker allows it. Throws the refusal when not (or cancelled). */
export async function changeStatusAsking(shopifyOrderId: string, status: string, isAdmin: boolean, ask: Ask = browserAsk) {
  let allowRepeats = false;
  let reason: string | undefined;
  // At most one question of each kind, then the answer stands.
  for (let i = 0; i < 3; i += 1) {
    try {
      return await ordersApi.updateStatus(shopifyOrderId, status, reason, allowRepeats);
    } catch (e) {
      if (!allowRepeats && isRepeatWarning(e)) {
        if (!ask.confirm(`${(e as Error).message}\n\nContinuer quand même ?`)) throw e;
        allowRepeats = true;
        continue;
      }
      if (reason === undefined && isAdmin && isNotPaid(e)) {
        const r = askOverrideReason((e as Error).message, ask.prompt);
        if (!r) throw e;
        reason = r;
        continue;
      }
      throw e;
    }
  }
  throw new Error('La mise à jour du statut a échoué. Réessayez.');
}
